export type AdvertisingAttribution = Partial<Record<
  | 'utm_source'
  | 'utm_medium'
  | 'utm_campaign'
  | 'utm_content'
  | 'utm_term'
  | 'gclid'
  | 'fbclid'
  | 'twclid'
  | 'initial_landing_url'
  | 'initial_referrer',
  string
>>;

const STORAGE_KEY = 'joybase_initial_advertising_attribution';

const QUERY_PARAM_KEYS: Array<keyof AdvertisingAttribution> = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'fbclid',
  'twclid',
];

const truncate = (value: string, maxLength = 2048) => value.slice(0, maxLength);

export const captureInitialAdvertisingAttribution = () => {
  if (typeof window === 'undefined') return;
  if (window.localStorage.getItem(STORAGE_KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const attribution: AdvertisingAttribution = {};

  QUERY_PARAM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      attribution[key] = truncate(value.trim());
    }
  });

  if (document.referrer) {
    attribution.initial_referrer = truncate(document.referrer);
  }

  if (Object.keys(attribution).length > 0) {
    attribution.initial_landing_url = truncate(window.location.href);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  }
};

export const getInitialAdvertisingAttribution = (): AdvertisingAttribution | undefined => {
  if (typeof window === 'undefined') return undefined;

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return undefined;

  try {
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return undefined;
    return parsed as AdvertisingAttribution;
  } catch {
    window.localStorage.removeItem(STORAGE_KEY);
    return undefined;
  }
};

export const clearInitialAdvertisingAttribution = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
};
